import { useState, useEffect } from "react";
import { Flex, IconButton, Separator, Tooltip } from "@radix-ui/themes";
import { AvatarDropdownMenu, LayoutButton } from "components";
import { ReactComponent as BWifiIcon } from "../assets/icons/favicon-dark.svg";
import { BoltIcon, BuildingOffice2Icon, UsersIcon, ChartPieIcon, DevicePhoneMobileIcon, ServerStackIcon, MapPinIcon } from "@heroicons/react/16/solid";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { TargetIcon } from "@radix-ui/react-icons";
import { useProfileContext } from "context";

export function MainLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { userProfile } = useProfileContext();
  
  // Helper function to get initial selection from pathname
  const getInitialSelection = (pathname) => {
    const path = pathname.split("/")[1]; // Get first segment after the root
    if (path === "dashboard") return "connections";
    if (path === "presence") return "presence";
    if (path === "portal-selector" || path === "portal-brand" || path === "portal-location") return "portal-selector";
    if (path === "networks" || path === "networks-selector") return "networks";
    if (path === "locations") return "locations";
    if (path === "contacts") return "contacts";
    return path || "connections";
  };

  const [sidebarSelection, setSidebarSelection] = useState(getInitialSelection(location.pathname));

  // Update selection when route changes
  useEffect(() => {
    setSidebarSelection(getInitialSelection(location.pathname));
  }, [location.pathname]);

  const handleSidebarSelection = (flag) => {
    setSidebarSelection(flag);
    if (flag === "presence") {
      navigate('/presence');
    } else if (flag === "connections") {
      navigate("/dashboard");
    } else if (flag === "portal-selector") {
      navigate("/portal-selector");
    } else if (flag === "networks") {
      navigate("/networks-selector");
    } else if (flag === "locations") {
      navigate("/locations");
    } else {
      navigate(flag);
    }
  };

  return (
    <Flex className="sidebar-main-container" style={{ alignSelf: "stretch" }} height="100%">
      <Flex className="sidebar-container" style={{ background: "var(--color-panel-solid)", height: "100%" }} 
        px="2" py="5" direction="column" justify="between" align="center">
        <IconButton size="3" variant="ghost" onClick={() => navigate("/dashboard")}>
          <BWifiIcon width="24" height="24" />
        </IconButton>
        <Flex className="sidebar-section-one" direction="column" align="center" gap="2">
          {/* <LayoutButton flag="chat" state={sidebarSelection} onClick={handleSidebarSelection} >
            <Tooltip content="Chat" side='right' sideOffset="1">
              <ChatBubbleLeftIcon width="24" height="24" color={ sidebarSelection === 'chat' ? 'white' : 'gray'}/>
            </Tooltip>
          </LayoutButton> */}
          <LayoutButton flag="connections" state={sidebarSelection} onClick={handleSidebarSelection}>
            <Tooltip content="Connections" side="right" sideOffset="1">
              <ChartPieIcon width="24" height="24" color={sidebarSelection === "connections" ? "white" : "gray"} />
            </Tooltip>
          </LayoutButton>
          { userProfile?.presence_feature_flag && (
            <LayoutButton flag="presence" state={sidebarSelection} onClick={handleSidebarSelection}>
              <Tooltip content="Presence" side="right" sideOffset="1">
                <TargetIcon width="24" height="24" color={sidebarSelection === "presence" ? "white" : "gray"} />
              </Tooltip>
            </LayoutButton>
          )}
          <LayoutButton flag="portal-selector" state={sidebarSelection} onClick={handleSidebarSelection}>
            <Tooltip content="Captive portal" side="right" sideOffset="1">
              <DevicePhoneMobileIcon width="24" height="24" color={sidebarSelection === "portal-selector" ? "white" : "gray"} />
            </Tooltip>
          </LayoutButton>
          <LayoutButton flag="networks" state={sidebarSelection} onClick={handleSidebarSelection}>
            <Tooltip content="Networks" side="right" sideOffset="1">
              <ServerStackIcon width="24" height="24" color={sidebarSelection === "networks" ? "white" : "gray"} />
            </Tooltip>
          </LayoutButton>
          <LayoutButton flag="locations" state={sidebarSelection} onClick={handleSidebarSelection}>
            <Tooltip content="Locations" side="right" sideOffset="1">
              <MapPinIcon width="24" height="24" color={sidebarSelection === "locations" ? "white" : "gray"} />
            </Tooltip>
          </LayoutButton>
          <LayoutButton flag="contacts" state={sidebarSelection} onClick={handleSidebarSelection}>
            <Tooltip content="Contacts" side="right" sideOffset="1">
              <UsersIcon width="24" height="24" color={sidebarSelection === "contacts" ? "white" : "gray"} />
            </Tooltip>
          </LayoutButton>
        </Flex>
        <Flex className="sidebar-section-two-container" display="flex" direction="column" align="center" gap="4">
          <Flex className="sidebar-section-two" display="flex" direction="column" align="start" gap="2">
            <LayoutButton flag="integrations" state={sidebarSelection} onClick={handleSidebarSelection}>
              <Tooltip content="Integrations" side="right" sideOffset="1">
                <BoltIcon width="24" height="24" color={sidebarSelection === "integrations" ? "white" : "gray"} />
              </Tooltip>
            </LayoutButton>
            <LayoutButton flag="organisation" state={sidebarSelection} onClick={handleSidebarSelection}>
              <Tooltip content="Organisation" side="right" sideOffset="1">
                <BuildingOffice2Icon width="24" height="24" color={sidebarSelection === "organisation" ? "white" : "gray"} />
              </Tooltip>
            </LayoutButton>
          </Flex>
          <AvatarDropdownMenu size="3" />
        </Flex>
      </Flex>
      <Separator orientation="vertical" size="4" />
      <Flex style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start", height: "100%", overflow: "auto" }}>
        {/* This is where the routed components will be rendered */}
        <Outlet />
      </Flex>
    </Flex>
  );
}
